import React from "react";

const labelTranslations = {
  name: "Emri i operatorit",
  shareHolders: "Pronësia",
  phoneNumber: "Numri i telefonit",
  address: "Adresa",
  email: "Emaili",
  oshma: "Oshma",
  id: "ID",
  legalForm: "Personi fizik ose juridik",
  TV: "TELEVIZIONE",
  RADIO: "Radiot",
  CABLE: "Kabllorët",
  OTHER: "Të tjerë",
};

const typeOrder = ["TV", "RADIO", "CABLE", "OTHER"];

const ModelViewShareholding = ({
  tableContent = [],
  customHeader = [],
  customFooter = [],
  excludedColumns = [],
}) => {
  if (!Array.isArray(tableContent) || tableContent.length === 0) {
    return <p>No data available</p>;
  }

  excludedColumns = ["id", "createdAt", "updatedAt"];
  const columnOrder = ["name", "legalForm", "shareHolders"];

  const groupedByType = tableContent.reduce((acc, item) => {
    const type = item.type || "OTHER";
    if (!acc[type]) acc[type] = [];
    acc[type].push(item);
    return acc;
  }, {});

  return (
    <>
      {typeOrder.map((type) => {
        const items = groupedByType[type];
        if (!items || items.length === 0) return null;

        const extractValidKeys = (data) => {
          const keys = new Set();
          data.forEach((item) => {
            Object.entries(item).forEach(([key, value]) => {
              const isExcluded =
                excludedColumns.includes(key) || key === "type";
              const isValid = typeof value !== "object" || value === null;
              if (!isExcluded && isValid) {
                keys.add(key);
              }
              if (key === "shareHolders") {
                keys.add(key);
              }
            });
          });
          return Array.from(keys);
        };

        const validKeys = extractValidKeys(items);
        const orderedKeys = columnOrder.filter((key) =>
          validKeys.includes(key)
        );

        return (
          <div key={type} style={{ marginBottom: "40px" }}>
            <h3
              style={{
                textTransform: "uppercase",
                margin: "20px 0 10px",
                color: "#f44336",
              }}
            >
              {labelTranslations[type] || type}
            </h3>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                textAlign: "center",
              }}
            >
              {/* Custom Header */}
              {customHeader.length > 0 && (
                <thead>
                  {customHeader.map((headerRow, index) => (
                    <tr
                      key={index}
                      style={{ backgroundColor: "#ED1D25", color: "#fff" }}
                    >
                      {Object.values(headerRow).map((cell, idx) => (
                        <th
                          key={idx}
                          style={{ padding: "10px", border: "1px solid #fff" }}
                        >
                          {cell}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
              )}

              {/* Table Header */}
              <thead>
                <tr style={{ backgroundColor: "#ED1D25", color: "#fff" }}>
                  {orderedKeys.map((header, index) => (
                    <th
                      key={index}
                      style={{ padding: "10px", border: "1px solid #fff" }}
                    >
                      {labelTranslations[header] || header}
                    </th>
                  ))}
                </tr>
              </thead>

              {/* Table Content */}
              <tbody>
                {items.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {orderedKeys.map((key, cellIndex) => (
                      <td
                        key={cellIndex}
                        style={{
                          padding: "10px",
                          border: "1px solid #000",
                          verticalAlign: "top",
                        }}
                      >
                        {key === "shareHolders" && Array.isArray(row[key]) ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "4px",
                              fontSize: "14px",
                            }}
                          >
                            {row[key].map((sh, idx) => (
                              <div
                                key={idx}
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <span>{sh.name}</span>
                                <span>({sh.percentage}%)</span>
                              </div>
                            ))}
                          </div>
                        ) : (
                          row[key] ?? ""
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>

              {/* Custom Footer */}
              {customFooter.length > 0 && (
                <tfoot>
                  {customFooter.map((footerRow, index) => (
                    <tr
                      key={index}
                      style={{ backgroundColor: "#f44336", color: "#fff" }}
                    >
                      {Object.values(footerRow).map((cell, idx) => (
                        <td
                          key={idx}
                          style={{ padding: "10px", border: "1px solid #fff" }}
                        >
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tfoot>
              )}
            </table>
          </div>
        );
      })}
    </>
  );
};

export default ModelViewShareholding;
